import { render, staticRenderFns } from "./page-header-scene-viewer.vue?vue&type=template&id=6d80fd6b&scoped=true"
import script from "./page-header-scene-viewer.vue?vue&type=script&lang=js"
export * from "./page-header-scene-viewer.vue?vue&type=script&lang=js"
import style0 from "./page-header-scene-viewer.vue?vue&type=style&index=0&id=6d80fd6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d80fd6b",
  null
  
)

export default component.exports